import styled from '@emotion/styled'

import { Spacing } from '../../../../../../enums/spacing'

export const MonthHeaderActionsWrapper = styled.header`
  display: flex;
  margin-bottom: ${Spacing.S24};
`

export const MonthsNavigation = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${Spacing.S16};
`

export const MonthNameWrapper = styled.div`
  width: 95px;
`

export const YearSelectWrapper = styled.div`
  flex: 1;
`
